var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 32,
    viewBox: "0 0 35 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    d: "M5.002 6.5h22.996M5.002 10.5h22.996M5.002 14.5h22.996M5.002 18.5h13.996M32.51 12.46V.57H.581v30.906h31.927v-6.875"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "rgba(21, 87, 191, 0.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.871 23.838L22 27.099l3.283-.814zM23.23 23.271L32.48 14l2.473 2.527-9.213 9.306z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentMarketing);
export default __webpack_public_path__ + "static/media/content-marketing.5111e0cbc17a8eb6c4f71bf75496e474.svg";
export { ForwardRef as ReactComponent };